import React from 'react';

const BaseCheckbox = ({
  id,
  name,
  checked = false,
  onChange,
  disabled = false,
  required = false,
  label,
  description,
  className = '',
  size = 'md',
  variant = 'default',
  indeterminate = false,
  ...props
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  const variantClasses = {
    default: 'text-vox-blue-600 bg-white border-gray-300 focus:ring-vox-blue-500 focus:ring-2',
    primary: 'text-vox-blue-600 bg-white border-vox-blue-300 focus:ring-vox-blue-500 focus:ring-2',
    success: 'text-green-600 bg-white border-green-300 focus:ring-green-500 focus:ring-2',
    warning: 'text-yellow-600 bg-white border-yellow-300 focus:ring-yellow-500 focus:ring-2',
    danger: 'text-red-600 bg-white border-red-300 focus:ring-red-500 focus:ring-2'
  };

  const baseClasses = `
    ${sizeClasses[size]}
    ${variantClasses[variant]}
    rounded
    border-2
    focus:outline-none
    transition-all
    duration-200
    ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:border-gray-400'}
    ${className}
  `;

  const handleChange = (e) => {
    if (!disabled && onChange) {
      onChange(e);
    }
  };

  return (
    <div className="flex items-start space-x-2">
              <div className="flex items-center h-4">
        <input
          type="checkbox"
          id={id}
          name={name}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          required={required}
          ref={(el) => {
            if (el && indeterminate) {
              el.indeterminate = true;
            }
          }}
          className={baseClasses}
          {...props}
        />
      </div>
      {(label || description) && (
        <div className="flex flex-col space-y-0.5">
          {label && (
            <label
              htmlFor={id}
              className={`
                text-xs font-medium
                ${disabled ? 'text-gray-400 cursor-not-allowed' : 'text-gray-700 dark:text-gray-300 cursor-pointer'}
              `}
            >
              {label}
              {required && <span className="text-red-500 ml-1">*</span>}
            </label>
          )}
          {description && (
            <p className="text-xs text-gray-500 dark:text-gray-400">
              {description}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default BaseCheckbox; 